// src/features/watchdog.ts
import { emit } from "../core/events";

export function startWatchdog(opts: { debug?: boolean } = {}) {
  if (typeof window === "undefined") return () => {};

  const code = `
    let lastPing = Date.now();
    self.onmessage = (e) => {
      if (e.data === "ping") {
        lastPing = Date.now();
        self.postMessage("pong");
      }
    };
    setInterval(() => {
      if (Date.now() - lastPing > 3000) {
        self.postMessage({ tamper: "worker-missed-main", ts: Date.now() });
      }
    }, 1000);
  `;
  const blob = new Blob([code], { type: "text/javascript" });
  const worker = new Worker(URL.createObjectURL(blob), { name: "JSentinelWD" });

  // 🔧 DEBUG: for console access (optional)
  if (opts.debug) {
    (window as any).__JSENTINEL_WD__ = worker;
  }

  let lastPong = Date.now();
  worker.onmessage = (e) => {
    if (e.data === "pong") lastPong = Date.now();
    else if (e.data?.tamper && e.data?.ts) {
      // Skip tamper while hidden; otherwise emit an event
      if (document.visibilityState !== "hidden")
        emit({ type: "tamper.jsentinel", data: { reason: e.data.tamper, ts: e.data.ts } });
    }
  };

  const timer = setInterval(() => {
    try {
      worker.postMessage("ping");
    } catch {}
    // Skip while page is hidden to avoid false positives when tab is backgrounded
    if (document.visibilityState === "hidden") return;
    if (Date.now() - lastPong > 3000)
      emit({ type: "tamper.jsentinel", data: { reason: "main-missed-worker", ts: Date.now() } });
  }, 1000);

  return () => {
    clearInterval(timer);
    try {
      worker.terminate();
    } catch {}
  };
}
